import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/primeng';
import { environment } from '../../../environments/environment';
import { AppComponent } from '../../app.component';
import { LoggedInUser, LoggedInUserCompany } from '../../models/loggedinuser.model';
import { AuthService } from '../../services/user/auth.service';
import { UsersService } from '../../services/user/users.service';
// import {MessageService} from 'primeng/api';

@Component({
  templateUrl: 'login.html'
})

export class LoginComponent {
  companies: SelectItem[];
  selectedCompany: number;
  step: number = 1;
  rememberMe = false;
  loginUsername: string;
  growlMsgs = [];
  version: string = environment.VERSION;

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UsersService,
    private localStorageService: LocalStorageService,
    private rootComp: AppComponent,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private svcNotify: MessageService,
    private appComponent: AppComponent
  ) {
    this.rootComp.cssClass = 'login-body';
  }

  ngOnInit() {
    this.authService.checkTokenLogin();
  }

  //  on login mask submit
  onLoginSubmit(
    e,
    username: HTMLInputElement,
    password: HTMLInputElement,
    rememberMe: HTMLInputElement): void {
    e.preventDefault();
    this.rememberMe = rememberMe.checked;
    this.loginUsername = username.value;

    /*

    this.authService.login(username.value, password.value).subscribe(res => {
      if (res.ok) {
        console.log('Login con successo');
        var loginData = res.json();
        this.authService.user = new LoggedInUser();
        this.authService.user.token = loginData.access_token;
        this.authService.user.tokenExpiresAt = Math.floor(new Date().getTime() / 1000) + loginData.expires_in;
        var tokExp = (this.authService.user.tokenExpiresAt * 1000 - Date.now()) / 1000;
        console.log('token expires in ' + Math.floor(tokExp / 60) + ' minutes and ' + Math.floor(tokExp % 60) + ' seconds');
        this.authService.user.refreshToken = loginData.refresh_token;
        //  decodifica dell'id_token con i dati dell'utente
        var base64Url = loginData.id_token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        var userData = JSON.parse(window.atob(base64));
        //  console.log(userData);
        this.authService.user.id = userData.koncentro_user_id;
        this.authService.user.role = userData.koncentro_user_role;
        this.authService.user.login = userData.koncentro_user_name;
        this.authService.user.firstName = userData.given_name;
        this.authService.user.lastName = userData.last_name;
        this.authService.user.accountLock = userData.accountLock;
        this.authService.user.companies = [];
        console.log('userData companies', userData.koncentro_user_companies)
        if (userData.koncentro_user_companies != null && userData.koncentro_user_companies != '') {
          var records = userData.koncentro_user_companies.split(';');
          if (records.length > 0) {
            for (let record of records) {
              if (record != '') {
                var splitRecord = record.split(':');
                this.authService.user.companies.push(new LoggedInUserCompany(splitRecord[0], splitRecord[1]));
              }
            }
          }
        }
        //  if the user account is locked, i need to enforce password change
        if (this.authService.user.accountLock) {
          console.log('user account locked');
          this.step = 3;
          return;
        }
        //  if there is more than one compnay, i need to ask to the user to choose one
        if (this.authService.user.companies.length > 1) {
          this.companies = [];
          for (let userCompany of this.authService.user.companies) {
            this.companies.push({label: userCompany.descr, value: userCompany.id});
          }
          this.step = 2;
          this.selectedCompany = this.companies[0].value;
        } else {
          //  otherwise, let's go the homepage
          if (this.authService.user.companies.length == 1) this.authService.user.selectedCompany = this.authService.user.companies[0].id;
          this.storeDataAndGoToTheHomePage();
        }
        //  console.log(('Nuovo oggetto user locale:'))
        //  console.log(this.authService.user);
      } else {
        console.log('Errore in fase di login... 1');
        this.loginError();
      }
    }, err => {
      console.log('Errore in fase di login... 2');
      this.loginError();
    });
    */


    this.authService.login_v2(username.value, password.value).subscribe((res) => {
      if (res.ok) {

        let resData: any = JSON.parse(res._body).rsp_data;
        if (resData) {
          console.log('Login con successo');
          var loginData = res.json();
          this.authService.user = new LoggedInUser();
          this.authService.user.token = resData.access_token;

          if (['it', 'en'].indexOf(this.translate.getBrowserLang()) != -1) {
            this.authService.sessionHelper.selectedLanguage = this.translate.getBrowserLang();
            this.authService.user.language = this.translate.getBrowserLang();
          } else {
            this.authService.sessionHelper.selectedLanguage = 'en';
            this.authService.user.language = 'en';
          }


          /*
           durata del limite di refresh token
           10 vuol dire che se il token entro 10 minuti scade, allora c'è bisogno di refresh
           */
          this.authService.user.tokenMinuteLimit = 11;
          //this.authService.user.tokenMinuteLimit = 2; //per prova


          let now: Date = new Date();

          //scadenza token restituito dalla chiamata (scadenza reale del token):
          let realExpiresSeconds = resData.expires_in;
          //realExpiresSeconds = 60 * 3; // per prova
          let secondsNow = now.getSeconds();
          now.setSeconds(secondsNow + realExpiresSeconds);

          //Durante il salvataggio dello Storage, questo campo viene salvato senza contare le ore aggiuntive durante il DST
          //Per ottenere l'orario giusto, usare new Date(tokenExpireDate)
          this.authService.user.tokenExpireDate = now;

          //this.authService.user.tokenExpiresAt = Math.floor(new Date().getTime() / 1000) + loginData.expires_in;
          this.authService.user.refreshToken = resData.refresh_token;
          //  decodifica dell'id_token con i dati dell'utente
          var base64Url = resData.id_token.split('.')[1];
          var base64 = base64Url.replace('-', '+').replace('_', '/');
          var userData = JSON.parse(window.atob(base64));
          this.authService.user.id = userData.koncentro_user_id;
          this.authService.user.role = userData.koncentro_user_role;
          this.authService.user.login = userData.koncentro_user_name;
          this.authService.user.firstName = userData.given_name;
          this.authService.user.lastName = userData.last_name;
          this.authService.user.accountLock = userData.accountLock;
          this.authService.user.companies = [];
          console.log('userData companies', userData.koncentro_user_companies)
          if (userData.koncentro_user_companies != null && userData.koncentro_user_companies != '') {
            var records = userData.koncentro_user_companies.split(';');
            if (records.length > 0) {
              for (let record of records) {
                if (record != '') {
                  var splitRecord = record.split(':');
                  this.authService.user.companies.push(new LoggedInUserCompany(splitRecord[0], splitRecord[1]));
                }
              }
            }
          }
          //  if the user account is locked, i need to enforce password change
          if (this.authService.user.accountLock) {
            console.log('user account locked');
            this.step = 3;
            return;
          }
          //  if there is more than one compnay, i need to ask to the user to choose one
          if (this.authService.user.companies.length > 1) {
            this.companies = [];
            for (let userCompany of this.authService.user.companies) {
              this.companies.push({ label: userCompany.descr, value: userCompany.id });
            }
            this.step = 2;
            this.selectedCompany = this.companies[0].value;
          } else {
            //  otherwise, let's go the homepage
            if (this.authService.user.companies.length == 1) this.authService.user.selectedCompany = this.authService.user.companies[0].id;
            this.storeDataAndGoToTheHomePage();
          }
          //  console.log(('Nuovo oggetto user locale:'))
          //  console.log(this.authService.user);
        }
        else {
          console.log('Errore in fase di login... 1');
          this.loginError(res);
        }

      } else {
        console.log('Errore in fase di login... 2');
        this.loginError(res);
      }
    }, err => {
      console.log('Errore in fase di login... 3');
      this.genericError(err);
    });


  }

  loginError(resError: any): void {
    this.translate.get(['login.loginError', 'login.loginErrorIdentityServer'
        , 'login.loginErrorUnexpectedError', 'login.loginErrorGenericError'])
      .subscribe((res) => {
        let error: any = JSON.parse(resError._body);

        if (error.rsp_code == '4080009') {
          console.error('loginError:' + error.rsp_msg)
          this.svcNotify.add({ severity: 'error', detail: res['login.loginErrorIdentityServer'] });
          return;
        } else if (error.rsp_code == '4080999') {
          console.error('loginError:' + error.rsp_msg)
          this.svcNotify.add({ severity: 'error', detail: res['login.loginErrorUnexpectedError'] });
          return;
        } else {
          this.svcNotify.add({ severity: 'error', detail: res['login.loginError'] });
        }
      });
  }

  genericError(resError: any): void {
    this.translate.get(['login.loginErrorGeneric']).subscribe((res) => {
      let resError: any = JSON.parse(res._body);
      this.svcNotify.add({
        severity: 'error', detail: res['login.loginErrorGeneric']
          + resError.status + ' - ' + resError.rsp_msg
      });
    });
  }


  //  store data to local storage and navigate to the homepage
  storeDataAndGoToTheHomePage(): void {
    this.userService.getApplicationsForUserCompany(this.authService.user.id, this.authService.user.selectedCompany).subscribe(
      (res) => {
        this.translate.reloadLang(this.translate.currentLang);
        this.authService.user.enabledUserApps = res;

        // FIXME: this should be removed
        this.authService.user.enabledApplications = [];
        for (let entry of res) {
          this.authService.user.enabledApplications.push(entry.application_id);
        }
        // ENDFIXME

        if (this.rememberMe) this.localStorageService.set('userData', this.authService.user);
        else sessionStorage.setItem('userData', JSON.stringify(this.authService.user));

        this.router.navigateByUrl('/');

        this.rootComp.cssClass = 'main-body';
      }
    )
  }

  //  on select company mask submit
  onCompanySubmit(e): void {
    e.preventDefault();
    //  console.log('on company submit. Selected company: ' + this.selectedCompany);
    this.authService.user.selectedCompany = this.selectedCompany;
    this.storeDataAndGoToTheHomePage();
  }

  //  on password change
  onChangePasswordSubmit(e, newPassword, confirmPassword): void {
    e.preventDefault();
    console.log('change password request');
    if (newPassword.value !== confirmPassword.value) {
      this.translate.get(['login.passwordsNoMatch']).subscribe((res) => {
        const msg = res['login.passwordsNoMatch'];

        this.svcNotify.add({ severity: 'error', summary: 'Password Error', detail: msg });
        console.log('Change password, conferma password non coincide');
      });
      return;
    }

    this.userService.changePassword(newPassword.value, confirmPassword.value).subscribe(() => {
      // backend change_password non ritorna token e invalida il vecchio access token (KS: invalidateUserTokens).
      // Ri-login con la nuova password per ottenere un token fresco ed entrare direttamente nell'app.
      this.authService.user.accountLock = false;

      this.authService.login_v2(this.loginUsername, newPassword.value).subscribe((res) => {
        if (res.ok) {
          const resData: any = JSON.parse(res._body).rsp_data;
          if (resData) {
            this.authService.user.token = resData.access_token;
            this.authService.user.refreshToken = resData.refresh_token;
            const now = new Date();
            now.setSeconds(now.getSeconds() + resData.expires_in);
            this.authService.user.tokenExpireDate = now;

            // createAuthorizationHeader ricarica user dallo storage a ogni richiesta:
            // persisto subito il token fresco, altrimenti le call successive ripescano il vecchio token (403).
            if (this.localStorageService.get('userData') != null) {
              this.localStorageService.set('userData', this.authService.user);
            } else if (sessionStorage.getItem('userData') != null) {
              sessionStorage.setItem('userData', JSON.stringify(this.authService.user));
            }
          }
        }

        if (this.authService.user.companies.length > 1) {
          this.companies = [];
          for (let userCompany of this.authService.user.companies) {
            this.companies.push({ label: userCompany.descr, value: userCompany.id });
          }
          this.step = 2;
          this.selectedCompany = this.companies[0].value;
        } else {
          //  otherwise, let's go the homepage
          if (this.authService.user.companies.length == 1) {
            this.authService.user.selectedCompany = this.authService.user.companies[0].id;
          }
          this.storeDataAndGoToTheHomePage();
        }
      });
    });
  }

  displayForgot: boolean = false;
  onPasswordForget() {
    console.log('forget')
    //  this.translate.get(['login.passwordsNoMatch']).subscribe((res) => {
    //    this.confirmationService.confirm({
    //      message: 'In caso di password dimenticata, contattare il numero verde di asssistenza 800-999999',
    //      header: 'Password dimenticata',
    //      key: 'forgotPassword'
    //    });
    //  })
    this.displayForgot = true;

  }
}



// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts